import React from "react";
import { Col, Pagination, Row, Spin, Button as AntButton } from "antd";
import Grid from "../../../../atoms/Grid";
import { torLedgerColumns } from "../utils";
import { useTurnoverLedger } from "../../hooks/useTurnoverLedger";

import { useAgGridSelection } from "../../../../../hooks/useAgGridSelection";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useViewAttachDocument } from "../../../../../hooks/useViewAttachDocument";



const index = () => {
  // variables
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  const { leaseId = bookingDetails.leaseId } = useParams();
  const { data, total, page, limit, loading, error, refetch, setPage, setLimit } = useTurnoverLedger({ leaseId });
  const { selectedIds, selectionLoading, deselectAll, onSelectionChanged, postSelectedIds } = useAgGridSelection({
    postUrl: "/booking/turnoverReportStatusUpdate",
    status: "approved",
    leaseId,
  });
  const { viewAttachDocument, loading: docGetLoading } = useViewAttachDocument();
  const viewAttachment = async (documentId) => {
    await viewAttachDocument(documentId);
  };

  return (
    <Col span={24} className="view-booking">
      <Pagination
        pageSize={limit}
        className="ag-property-text-pagination"
        total={total}
        showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Reports`}
        defaultPageSize={limit}
        defaultCurrent={1}
        showSizeChanger={false}
        current={page}
        onChange={(e) => setPage(e)}
      />

      {loading ? (
        <Row gutter={24} className="loading" style={{ marginTop: "20px" }}>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "20vh" }}>
            <Spin size="large" />
          </div>
        </Row>
      ) : (
        <>
          <Row gutter={12} justify={"end"} style={{ marginTop: "20px" }}>
            <Col>
              <AntButton
                className="ef-approve-btn"
                onClick={() => postSelectedIds()}
                type="primary"
                disabled={selectedIds?.length === 0 || selectionLoading}
              >
                {selectionLoading ? "Loading..." : "Approve Selected Reports"}
              </AntButton>
            </Col>
          </Row>
          <Row style={{ marginTop: "20px" }}>
            <Col span="24">
              <Grid
                columns={torLedgerColumns(viewAttachment)}
                height={"315px"}
                rowSelection="multiple"
                className={"header-height-settings tor-ledger-grid"}
                onSelectionChanged={onSelectionChanged}
                data={data}
                headerHeight={50}
                deselectAll={deselectAll}
                isRowSelectable={false}
                fullPage={true}
              />
            </Col>
          </Row>
        </>
      )}
    </Col>
  );
};

export default React.memo(index);
